import AACChromeAPI from '@amzn/aac-chrome-api';
import { getClickEventHandler } from 'src/commons/utils';
import { PivotNavItem } from 'src/app/slice';
import { PivotNavMetricPublisher } from 'src/commons/utils/metrics';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

export interface CommonPivotItemProps {
  label: string;
  href?: string;
  onClick: (event) => void;
  'data-ccx-e2e-id': string;
  'data-eventid': string;
  'data-takt-id'?: string;
  'data-takt-value'?: string;
}

export const getCommonPivotItemProps = (
  item: PivotNavItem,
  transformUrl?: (url: string) => string,
): CommonPivotItemProps => {
  const trimmedUrl = item?.url?.trim();
  const resolvedUrl =
    trimmedUrl && transformUrl ? transformUrl(trimmedUrl) : trimmedUrl;
  return {
    label: item.label,
    href: resolvedUrl || undefined,
    onClick: (event) => {
      PivotNavMetricPublisher.publishCounterMonitor(
        `pivotNavItemClicked-${item.id}`,
        1,
      );
      const eventHandler = getClickEventHandler(
        item,
        AACChromeAPI.getPivotEventTarget(),
      );
      eventHandler(event);
    },
    'data-ccx-e2e-id': `aac-pivot-item-${item.id}`,
    'data-eventid': item.id,
    ...getTaktAttributes(
      'link',
      chromeComponents.PIVOT_NAV,
      resolvedUrl ? { url: resolvedUrl } : {},
    ),
  };
};
